import apiClient from "./apiClient";
import {removeNullFields} from "@/utils/utils";
import {TemplateTypeEnum} from "@/enum/TemplateTypeEnum";

const BASE_URL = process.env.VUE_APP_BASE_URL as string;

const xlsExportService = {

    async exportStudents(templateType: TemplateTypeEnum, params: any): Promise<any> {
        try {
            const token = localStorage.getItem("access_token");

            const paramsCopy = structuredClone(params);
            paramsCopy.filter = removeNullFields(paramsCopy.filter);
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/student/export/${templateType}`,
                paramsCopy,
                {
                    responseType: "blob",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                }
            )
            return response.data;
        } catch (error) {
            console.error("Error export students", error);
            throw error;
        }
    },

    async exportStudentsCredits(templateType: TemplateTypeEnum, params: any): Promise<any> {
        try {
            const token = localStorage.getItem("access_token");

            const paramsCopy = structuredClone(params);
            paramsCopy.filter = removeNullFields(paramsCopy.filter);
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/student-credits/export/${templateType}`,
                paramsCopy,
                {
                    responseType: "blob",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                }
            )
            return response.data;
        } catch (error) {
            console.error("Error export students", error);
            throw error;
        }
    },

    async exportStudentsNutritionTemplate(): Promise<any> {
        try {
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/student-nutrition/exportTemplate`,
                {
                    responseType: "blob"
                }
            )
            return response.data;
        } catch (error) {
            console.error("Error export students nutrition", error);
            throw error;
        }
    },

    async exportEcoPaymentTemplate(): Promise<any> {
        try {
            const token = localStorage.getItem("access_token");
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/eco-payment/exportTemplate`,
                null,
                {
                    responseType: "blob",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                }
            )
            return response.data;
        } catch (error) {
            console.error("Error export eco template", error);
            throw error;
        }
    },

    async exportStudentsTrainingDuration(templateType: TemplateTypeEnum, params: any): Promise<any> {
        try {
            const token = localStorage.getItem("access_token");

            const paramsCopy = structuredClone(params);
            paramsCopy.filter = removeNullFields(paramsCopy.filter);
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/student-training-duration/export/${templateType}`,
                paramsCopy,
                {
                    responseType: "blob",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                }
            )
            return response.data;
        } catch (error) {
            console.error("Error export students", error);
            throw error;
        }
    },

    async exportMilitaryStudents(templateType: TemplateTypeEnum, params: any): Promise<any> {
        try {
            const token = localStorage.getItem("access_token");

            const paramsCopy = structuredClone(params);
            paramsCopy.filter = removeNullFields(paramsCopy.filter);
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/military-student/export/${templateType}`,
                paramsCopy,
                {
                    responseType: "blob",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                }
            )
            return response.data;
        } catch (error) {
            console.error("Error export military students", error);
            throw error;
        }
    },

    async exportReports(params: any): Promise<any> {
        try {
            const token = localStorage.getItem("access_token");

            const paramsCopy = structuredClone(params);
            paramsCopy.filter = removeNullFields(paramsCopy.filter);
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/report/exportReports`,
                paramsCopy,
                {
                    responseType: "blob",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                }
            )
            return response.data;
        } catch (error) {
            console.error("Error export reports", error);
            throw error;
        }
    },

    async exportStudentsNutrition(params: any): Promise<any> {
        try {
            const token = localStorage.getItem("access_token");

            const paramsCopy = structuredClone(params);
            paramsCopy.filter = removeNullFields(paramsCopy.filter);
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/student-nutrition/exportStudentsNutrition`,
                paramsCopy,
                {
                    responseType: "blob",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                }
            )
            return response.data;
        } catch (error) {
            console.error("Error export students nutrition", error);
            throw error;
        }
    },

    async exportEcoPayment(params: any): Promise<any> {
        try {
            const token = localStorage.getItem("access_token");

            const paramsCopy = structuredClone(params);
            paramsCopy.filter = removeNullFields(paramsCopy.filter);
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/eco-payment/export`,
                paramsCopy,
                {
                    responseType: "blob",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                }
            )
            return response.data;
        } catch (error) {
            console.error("Error export eco payment", error);
            throw error;
        }
    },
}

export default xlsExportService;